import CampaignPlatformType from '@/Enums/CampaignManagement/CampaignPlatformType.enum';
import ConfirmationModal from '@/components/Modal/ConfirmationModal';
import { CAMPAIGN_MANAGEMENT_ROW_TYPE } from '@/constants/campaignManagement';
import { useAppDispatch } from '@/store/hooks';
import {
  archiveCampaign,
  archiveDV360InsertionOrder,
  archiveDV360LineItem,
  archiveLineItem,
} from '@/store/slices/campaignManagementSlice';
import { Button, SxProps, Theme } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';

interface IProps {
  sx?: SxProps<Theme>;
  row: any;
}

const ArchiveButton = ({ sx, row }: IProps) => {
  const dispatch = useAppDispatch();
  const [isOpenedConfirmation, setIsOpenedConfirmation] = useState(false);

  const onActionClick = useCallback(async () => {
    setIsOpenedConfirmation(true);
  }, [setIsOpenedConfirmation]);

  const onConfirm = useCallback(async () => {
    const isDV360 = row.platform === CampaignPlatformType.Google;
    const shouldArchive = !row.isArchived;
    if (row.type === CAMPAIGN_MANAGEMENT_ROW_TYPE.LINE_ITEM) {
      const archiveAction = isDV360 ? archiveDV360LineItem : archiveLineItem;
      // @ts-ignore
      await dispatch(archiveAction({ lineItemId: row.lineItemId, isArchived: shouldArchive }));
    } else {
      const archiveAction = isDV360 ? archiveDV360InsertionOrder : archiveCampaign;
      // @ts-ignore
      await dispatch(archiveAction({ campaignId: row.campaignId, isArchived: shouldArchive }));
    }
    setIsOpenedConfirmation(false);
  }, [dispatch, row, setIsOpenedConfirmation]);

  const confirmationText = useMemo(
    () =>
      row.type === CAMPAIGN_MANAGEMENT_ROW_TYPE.LINE_ITEM
        ? `Are you sure you want to ${row.isArchived ? 'unarchive' : 'archive'} this line item "${row.campaignName}"?`
        : `Are you sure you want to ${row.isArchived ? 'unarchive' : 'archive'} this campaign "${row.campaignName}"?`,
    [row],
  );

  const onConfirmationClose = useCallback(() => {
    setIsOpenedConfirmation(false);
  }, [setIsOpenedConfirmation]);

  if (row.type === CAMPAIGN_MANAGEMENT_ROW_TYPE.FLIGHT) {
    return null;
  }

  return (
    <>
      <Button
        variant='outlined'
        color='primary'
        sx={{
          minHeight: '29px',
          padding: 0,
          paddingX: '8px',
          marginLeft: '8px',
          borderRadius: '32px',
          textWrap: 'nowrap',
          minWidth: 'unset',
          ...sx,
        }}
        onClick={onActionClick}
      >
        {row.isArchived ? 'Unarchive' : 'Archive'}
      </Button>
      {isOpenedConfirmation && (
        <ConfirmationModal
          open={isOpenedConfirmation}
          onClose={onConfirmationClose}
          onConfirm={onConfirm}
          text={confirmationText}
        />
      )}
    </>
  );
};

export default ArchiveButton;
